import { render } from "./message-overview.vue?vue&type=template&id=889de41c"
import script from "./message-overview.vue?vue&type=script&lang=js"
export * from "./message-overview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__